import { EventEmitter } from "@angular/core";
import { AbstractControl } from "@angular/forms";
import { PostAreaAPI, PostAreaDto } from "src/app/services/api-service/postarea-api";
import { UserConfirmService } from "src/app/services/user-confirm.service";
import { ValueTextPair } from "../models/value-text-pair";
import { FunctionEnable } from "src/app/services/base-config.service";
import { ClinicDataService } from "src/app/services/data-service/clinic-data-service";

export class ZipCodeHelper {

  private city: ValueTextPair[] = [];
  private area: ValueTextPair[] = [];
  private areaFilterd: ValueTextPair[];
  private roadFilter: ValueTextPair[] = [];
  private status: boolean = true;
  private cityControl: AbstractControl;
  public onAreaChange = new EventEmitter<{ City: ValueTextPair[], Area: ValueTextPair[], Road: ValueTextPair[] }>();
  public onChanged = new EventEmitter<{ City: string, Area: string, Zip: string, Street?: string }>();
  public disable() {
    this.status = false;
  }
  public enable() {
    this.areaFilterd = this.area.filter(a => a.value == this.cityControl.value)
      .map(v => { return { text: v.text, value: v.text }; });
    this.status = true;
    this.onAreaChange.emit({ City: this.city, Area: this.areaFilterd, Road: this.roadFilter });
  }
  constructor(
    public postAreaApi: PostAreaAPI,private clinicData:ClinicDataService,
    userConfirm: UserConfirmService,
    zipcodeEl: HTMLInputElement,
    zipcodeControl: AbstractControl,
    cityControl: AbstractControl,
    areaControl: AbstractControl,
    streetControl: AbstractControl) {
    this.cityControl = cityControl;
    var emit = () => {
      this.onChanged.emit({
        City: cityControl.value,
        Area: areaControl.value,
        Zip: zipcodeControl.value,
        Street: streetControl.value
      });
    }
    cityControl.valueChanges.subscribe(async (value) => {
      if (value && this.status) {

        this.areaFilterd = this.area.filter(a => a.value == value).map(v => { return { text: v.text, value: v.text }; });

        if (!this.areaFilterd.find(v => v.text == areaControl.value)) {
          areaControl.setValue('', { emitEvent: false });

        }
        else{
           if (streetControl) {
            this.roadFilter = await postAreaApi.GetRoads(cityControl.value, areaControl.value);
          }
        }
        this.onAreaChange.emit({ City: this.city, Area: this.areaFilterd, Road: this.roadFilter });
        // console.log('set city to', value)
        emit();
      }
      //this.updateIsMountain();
    });

    areaControl.valueChanges.subscribe(async value => {
      //this.updateIsMountain();
      if (cityControl.value && areaControl.value && this.status) {
        var zipCode = await postAreaApi.GetZip(cityControl.value, areaControl.value);
        var zipstr = zipcodeControl.value ? zipcodeControl.value.toString() : '';
        if (!zipstr.startsWith(zipCode)) {
          zipcodeControl.setValue(zipCode, { emitEvent: false });
        }

        if (streetControl) {

          this.roadFilter = await postAreaApi.GetRoads(cityControl.value, areaControl.value);
          this.onAreaChange.emit({ City: this.city, Area: this.areaFilterd, Road: this.roadFilter });
        }

        // console.log('set area to', value, zipCode)
        emit();
      }


    });

    zipcodeEl.onchange = async value => {
      if (!zipcodeControl.value || !this.status) {
        return;
      }
      var postArea = await postAreaApi.GetByZip(zipcodeControl.value);
      if (!postArea) {
        return;
      }
      // 其中一個有值 而且縣市/鄉鎮市區沒完全一樣
      if ((cityControl.value || areaControl.value) &&
        !(cityControl.value == postArea.City &&
          areaControl.value == postArea.Area)) {

        var msg = `是否將縣市/鄉鎮市區變更為[${postArea.City}]/[${postArea.Area}]？`
        if (!(postArea.Area + postArea.City)) {
          msg = '查無郵遞區號資料，是否清除縣市/鄉鎮欄位？'
        }

        var ret = await userConfirm.showConfirm({
          msg: msg,
          width: 400,
        });
        if (ret == false) {
          return;
        }
      }

      cityControl.setValue(postArea.City, { emitEvent: false });
      this.areaFilterd = this.area.filter(a => a.value == cityControl.value).map(v => { return { text: v.text, value: v.text }; });
      this.onAreaChange.emit({ City: this.city, Area: this.areaFilterd, Road: this.roadFilter });
      setTimeout(() => {

        areaControl.setValue(postArea.Area, { emitEvent: false });
        // if (!streetControl.value) {
        //   streetControl.setValue(postArea.Road, { emitEvent: false });
        // }
        emit();
      }, 0);

      //await this.updateIsMountain();
    };
  }
  async init() {
    var ret :PostAreaDto;
    if(FunctionEnable.EnableClientAdvCache){
      ret = await this.clinicData.GetCityArea()
    }else{
      ret = await this.postAreaApi.GetCityArea();
    }
    this.city = ret.city.map(s => { return { value: s, text: s }; });
    this.area = ret.area;
    this.areaFilterd = this.area.filter(a => a.value == this.cityControl.value)
      .map(v => { return { text: v.text, value: v.text }; });
    this.onAreaChange.emit({ City: this.city, Area: this.areaFilterd, Road: this.roadFilter });

  }

}
